import { Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import debounce from 'lodash/debounce';

import store from './Store';
import Table from './Table';
import Modal from './Modal';
import Toolbar from './Toolbar';
import ui from '../../../stores/dashboard';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

class DomainExclusion extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/domain-exclusion', true);
      return;
    }

    this._searchDebounced();
  }
  _searchDebounced = debounce(() => {
    store.fetchData(true, 'byKeyword');
  }, 500);

  render() {
    const { loading, data, open } = store;
    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {loading && !data ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <Toolbar />
            <Table />
            {open && <Modal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default observer(DomainExclusion);
